<template>
  <ModalPortal :background-scroll="false">
    <div
      data-test-id="power_match_modal"
      class="modal-dialog modal-dialog-full h-full modal_match power"
    >
      <div class="modal-content h-full">
        <div class="modal-body text-center flex flex-col">
          <Close @click="close"></Close>

          <div class="mt-auto mb-auto">
            <div class="modal_match-title" data-test-id="modal_title">
              {{ t('chatRequest') }}
            </div>
            <div class="modal_match-img_group" data-test-id="modal_user_photos">
              <div class="modal_match-icon_center">
                <FontIcon class="icon-instant-chat_solid" />
              </div>
              <div class="modal_match-img modal_match-img_my">
                <RetinaPhoto
                  :photo-id="match.myAvatar?.id ?? ''"
                  :width="120"
                  :height="120"
                  img-width="100%"
                  alt="user's photo"
                ></RetinaPhoto>
              </div>
              <div class="modal_match-img modal_match-img_friend">
                <RetinaPhoto
                  :photo-id="match.avatar?.id ?? ''"
                  :width="120"
                  :height="120"
                  img-width="100%"
                  alt="user's photo"
                ></RetinaPhoto>
              </div>
            </div>
            <div class="modal_match-info" data-test-id="modal_match_info">
              <span v-html="t('greetChatRequest', { name: match.name })"></span>
            </div>
            <div v-if="!isPromoVisible" class="modal_match-btn mb-4">
              <button
                type="button"
                class="btn btn-light mb-0"
                data-test-id="start_chat_btn"
                @click="goChatPage()"
              >
                {{ t('startChat') }}
              </button>
            </div>
          </div>
          <ChatFooterIcebreaker
            class="power-ice-breaker !block rounded-lg"
            :ice-breakers="icebreakerList"
            @select="applyIcebreaker"
          />
          <ChatFooter
            v-if="isPromoVisible"
            tooltip-hint=""
            :gifts="giftList"
            :ice-breakers="icebreakerList"
            :dialog-id="match.dialogId"
            :is-inspiration-modal-visible="false"
            :user-id="match.userId"
            :is-hint-visible="false"
            :dialog-messages="['']"
            :are-messages-loaded="false"
            :is-power-expired="false"
            @message-sent="goChatPage()"
          ></ChatFooter>
        </div>
      </div>
    </div>
  </ModalPortal>
</template>

<script lang="ts" setup>
import { DialogGift } from '@project-gd-x/dating-site-contracts/src/gen/gdx/gateway/web/chat/v1/dialogs_pb';
import { computed, PropType } from 'vue';

import FontIcon from '@/components/inputs/icon/font-icon/FontIcon.vue';
import Close from '@/components/layout/components/header/components/close/Close.vue';
import ModalPortal from '@/components/modal/ModalPortal.vue';
import RetinaPhoto from '@/components/retina-image/RetinaPhoto.vue';
import ChatFooter from '@/pages/chat/components/chat-view/components/chat-footer/ChatFooter.vue';
import ChatFooterIcebreaker from '@/pages/chat/components/chat-view/components/chat-footer/components/chat-footer-icebreaker/ChatFooterIcebreaker.vue';
import { useChatFooter } from '@/pages/chat/components/chat-view/components/chat-footer/hooks/use-chat-footer/use-chat-footer';
import { useStoreChatIcebreakers } from '@/pages/chat/hooks/use-store-chat-icebreakers/use-store-chat-icebreakers';
import { pushRoute } from '@/router';
import { useI18n } from '@/services/i18n';
import { MatchStateNotification } from '@/store/modules/possibility/possibility-state';
import { dispatch, getState } from '@/store/store-helper';
import { ExtractClassFields } from '@/type';

import { messages } from './i18n';

const props = defineProps({
  match: {
    required: true,
    type: Object as PropType<MatchStateNotification>,
  },
  isPromoVisible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close']);

const { t } = useI18n({ messages });

const { loadIcebreakers, icebreakerList } = useStoreChatIcebreakers(props.match?.userId);

const giftList = computed<ExtractClassFields<DialogGift>[]>(() => {
  return getState().chat.gifts;
});

function close() {
  emit('close');
}

function goChatPage() {
  const chatId = props.match.dialogId;
  pushRoute('chatView', { chatId });
  close();
}

loadIcebreakers();

async function applyIcebreaker(icebreaker: string): Promise<void> {
  await sendTextMessage({
    messageText: icebreaker,
    dialogId: props.match.dialogId,
  });

  goChatPage();
}

const { sendTextMessage } = useChatFooter();

dispatch('actionChatGetGifts');
</script>

<style src="./style.scss" lang="scss" scoped></style>
